module.exports = __webpack_public_path__ + "img/img_homecard_bg.8ac618a5.svg";